export default __webpack_public_path__ + "static/media/gsoc.cd697799.png";